var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.canal == 3)?[(!_vm.isMobile)?_c('propio'):_c('propioMovil')]:_vm._e(),(_vm.user.canal == 1)?[(!_vm.isMobile)?_c('retail'):_c('retailMovil')]:_vm._e(),(_vm.user.canal == 4)?[(!_vm.isMobile)?_c('especialista'):_c('espMovil')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }